/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
if (typeof lazySizes !== 'function' && typeof lazySizes !== 'object') {
  /*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P--, (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++, _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
  general: {
    limit: boostPFSThemeConfig.custom.products_per_page,
    /* Optional */
    loadProductFirst: true,
    // Placeholder  
    showPlaceholderProductList: true,
    placeholderProductPerRow: 3,
    filterTreeMobileStyle: 'style3',
    placeholderProductGridItemClass: 'boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-3 boost-pfs-filter-grid-width-mb-2',
    enableOTP: true,
    selectOptionContainer: '.boost-pfs-filter-product-item-image',  // CSS selector to append the product option, if left empty it will append to the product item
  },
  selector: {
    otpButtons: '.boost-pfs-filter-product-item-image',
  }
};

(function () {
  var onSale = false,
    hasOriginalPrice = false,
    originalPriceSameComparePrice = false,
    soldOut = false,
    priceVaries = false,
    images = [],
    firstVariant = {},
    firstVariantMetafields = {},
    firstVariantOriginalPrice = null,
    boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
    boostPFSRangeWidths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048];

  BoostPFS.inject(this);
  boostPFSFilterConfig.general.separateRefineByFromFilter = (jQ('.boost-pfs-filter-tree-h').length && !Utils.isMobile() > 0) ? true : false;
  Selector.stickyElementDesktop = jQ('.boost-pfs-filter-tree-v').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';

  /************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  function prepareShopifyData(data) {
    // Displaying price base on the policy of Shopify, have to multiple by 100
    soldOut = !data.available; // Check a product is out of stock
    priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Convert images to array
    images = data.images_info;
    // Get First Variant (selected_or_first_available_variant)
    firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    firstVariantMetafields = data.metafields?.filter(item => item.id === firstVariant.id)
      .reduce((metafields, item) => {
        return {
          ...metafields,
          [`${item.namespace}.${item.key}`]: {
            ...item,
            value: item.type === 'money' ? JSON.parse(item.value) : item.value
          }
        }
      }, {});
    firstVariantOriginalPrice = firstVariantMetafields['prices.originalPrice']?.value?.amount ? Number(firstVariantMetafields['prices.originalPrice']?.value?.amount) : null;
    onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    hasOriginalPrice = firstVariantOriginalPrice > 0;
    originalPriceSameComparePrice = firstVariantOriginalPrice <= data.compare_at_price_min;
    return data;
  }

  /************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
  /************************** BUILD PRODUCT LIST **************************/
  // Build Product Grid Item
  ProductGridItem.prototype.compileTemplate = function (data) {

    if (!data) data = this.data;
    // Customize API data to get the Shopify data
    data = prepareShopifyData(data);

    // Get Template
    var itemHtml = boostPFSTemplate.productGridItemHtml;
    // Add Custom class
    var soldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
    var saleClass = onSale ? boostPFSTemplate.saleClass : '';

    var productHidden = data.handle === 'click-collect-free-shipping' || data.handle === 'assembly';
    if (productHidden) return '';

    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
    itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemActions}}/g, buildAction(data));
    itemHtml = itemHtml.replace(/{{itemTags}}/g, buildLabels(data));

    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, buildSwatch(data));
    itemHtml = itemHtml.replace(/{{itemSwatchesBottom}}/g, buildSwatchBottom(data));
    // Add Images
    itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));
    // Add Price
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));

    // Add Vendor
    itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendors(data));
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReviews(data));

    // Add main attribute (Always put at the end of this function)
    itemHtml = itemHtml.replace(/{{hideAddToCartClass}}/g, buildhideAddToCartClass(data));
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));
    return itemHtml;
  };
  /************************** END BUILD PRODUCT LIST **************************/
  /************************** BUILD PRODUCT ITEM ELEMENTS **************************/
  function buildReviews(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.enable_product_reviews)
      html = '<span class="shopify-product-reviews-badge" data-id="' + data.id + '"></span>'
    return html;
  }
  function buildVendors(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.vendor_enable)
      html = '<div class="grid-product__vendor">' + data.vendor + '</div>'
    return html;
  }
  function buildImages(data) {
    var html = '';
    if (images.length > 0) {
      var fixed_aspect_ratio = false;
      if (boostPFSThemeConfig.custom.product_grid_image_size != 'natural') {
        fixed_aspect_ratio = true;
      }
      var preview_image = Utils.getFeaturedImage(images, '1x1').replace('_1x1.', '_{width}x.')
      var img_url = Utils.getFeaturedImage(images, '400x')

      if (fixed_aspect_ratio) {
        html += '<div class="grid__image-ratio grid__image-ratio--' + boostPFSThemeConfig.custom.product_grid_image_size + '">';
        var classC = '';
        if (!boostPFSThemeConfig.custom.product_grid_image_fill) {
          classC = 'grid__image-contain';
        }
        var aspectRatio = images[0]['width'] / images[0]['height'];
        html += '<img class="lazyload ' + classC + '" data-src="' + preview_image + '" data-widths="[160, 200, 280, 360, 540, 720, 900]"   data-aspectratio="' + aspectRatio + '"  data-sizes="auto" alt="">';
        html += '<noscript>';
        html += '<img class="grid-product__image lazyloaded" src="' + img_url + '"';
        html += '</noscript>';
        html += '</div>';
      } else {
        html += '<div style="height: 0; padding-bottom: 100%;">'
        html += '<img class="grid-product__image lazyload" data-src="' + preview_image + '" data-widths="[360, 540, 720, 900, 1080]"  data-aspectratio="1.0" data-sizes="auto" alt="">'
        html += '<noscript>'
        html += '<img class="grid-product__image lazyloaded" src="' + img_url + '" alt="">'
        html += '</noscript>'
        html += '</div>'
      }
      if (boostPFSThemeConfig.custom.product_hover_image && images.length > 1) {

        html += '<div class="grid-product__secondary-image small--hide">'
        var aspectRatioS = images[1]['width'] / images[1]['height'];
        var second_image = Utils.optimizeImage(images[1]['src'], '1x1').replace('_1x1.', '_{width}x.')
        html += '<img class="lazyload" data-src="' + second_image + '" data-widths="[360, 540, 720, 1000]" data-aspectratio="' + aspectRatioS + '" data-sizes="auto" alt="">'
        html += '</div>'
      }
    }
    return html;
  }

  function buildPrice(data) {
    var html = '';
    if (hasOriginalPrice && (
      boostPFSThemeConfig.custom.show_product_original_price_in_PLP ||
      !(!originalPriceSameComparePrice && onSale) //case 3
    )) {
      html += '<span class="grid-item-original-price">';
      var formatted_original_price = Utils.formatMoney(firstVariantOriginalPrice).replace('.00', '')
      if (boostPFSAppConfig.shop.money_format.indexOf('money') == -1 || boostPFSAppConfig.shop.money_format.indexOf('.') == -1) {
        if (boostPFSThemeConfig.custom.superscript_decimals) {
          if (boostPFSAppConfig.shop.money_format.indexOf('{{amount}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount }}') == -1) {
            formatted_original_price = formatted_original_price.replace('.', '<sup>') + '</sup>'
          } else {
            if (boostPFSAppConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount_with_comma_separator }}') == -1) {
              formatted_original_price = formatted_original_price.replace(',', '<sup>') + '</sup>'
            }
          }
        }
      }

      var formatted_price_compare = Utils.formatMoney(data.compare_at_price_min).replace('.00', '')
      if (boostPFSAppConfig.shop.money_format.indexOf('money') == -1 || boostPFSAppConfig.shop.money_format.indexOf('.') == -1) {
        if (boostPFSThemeConfig.custom.superscript_decimals) {
          if (boostPFSAppConfig.shop.money_format.indexOf('{{amount}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount }}') == -1) {
            formatted_price_compare = formatted_price_compare.replace('.', '<sup>') + '</sup>'
          } else {
            if (boostPFSAppConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount_with_comma_separator }}') == -1) {
              formatted_price_compare = formatted_price_compare.replace(',', '<sup>') + '</sup>'
            }
          }
        }
      }

      html += `
        <span class="from-price">
          <span class="from-label">${formatted_original_price}</span>
          <svg class="arrow-icon arrow-down" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="m18.707 12.707-3 3a1 1 0 0 1-1.414-1.414L15.586 13H6a1 1 0 0 1 0-2h9.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414z" data-name="Right"/></svg>
        </span>
      `
      if (priceVaries) {
        html += '<span class="grid-product__price--current">'
        var formatted_price = Utils.formatMoney(data.price_min).replace('.00', '')
        var raw_price = Utils.formatMoney(data.price_min).replace('.00', '')
        if (boostPFSAppConfig.shop.money_format.indexOf('money') == -1 || boostPFSAppConfig.shop.money_format.indexOf('.') == -1) {

          if (boostPFSThemeConfig.custom.superscript_decimals) {
            if (boostPFSAppConfig.shop.money_format.indexOf('{{amount}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount }}') == -1) {
              formatted_price = formatted_price.replace('.', '<sup>') + '</sup>'
            } else {
              if (boostPFSAppConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount_with_comma_separator }}') == -1) {
                formatted_price = formatted_price.replace(',', '<sup>') + '</sup>'
              }

            }
          }
          html += '<span aria-hidden="true" class="grid-product__price--from">' + boostPFSThemeConfig.label.from_text_html.replace(/{{ price }}/g, formatted_price); +'</span>'
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.from_text_html.replace(/{{ price }}/g, raw_price); +'</span>'
        }
        html += '</span>'
      } else {
        if (onSale) {
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.on_sale + '</span>';
        }
        html += '<span class="grid-product__price--current">'
        html += (!originalPriceSameComparePrice && onSale && `<span class="to-label">${formatted_price_compare}</span>`) || ''
        var formatted_price = Utils.formatMoney(data.price_min).replace('.00', '')
        if (boostPFSAppConfig.shop.money_format.indexOf('money') == -1 || boostPFSAppConfig.shop.money_format.indexOf('.') == -1) {
          if (boostPFSThemeConfig.custom.superscript_decimals) {
            if (boostPFSAppConfig.shop.money_format.indexOf('{{amount}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount }}') == -1) {
              formatted_price = formatted_price.replace('.', '<sup>') + '</sup>'
            } else {
              if (boostPFSAppConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount_with_comma_separator }}') == -1) {
                formatted_price = formatted_price.replace(',', '<sup>') + '</sup>'
              }

            }
          }
          html += '<span ' + ((!originalPriceSameComparePrice && onSale) ? ' class="price-color-red" ' : '') + ' aria-hidden="true">' + formatted_price.replace('.00', '') + '</span>'
          html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_min).replace('.00', '') + '</span>'
        }
        html += '</span>'
      }

      // if(!originalPriceSameComparePrice && onSale) {
      //   var saved_amount = 0;
      //   if( boostPFSThemeConfig.custom.product_save_amount){
      //     if(boostPFSThemeConfig.custom.product_save_type == 'dollar'){
      //         saved_amount = Utils.formatMoney(data.compare_at_price_min - data.price_min).replace('.00','');
      //     }else{
      //       saved_amount = Math.round(((data.compare_at_price_min - data.price_min)*100.0)/ data.compare_at_price_min) + '%';
      //     }
      //     html += '<span class="grid-product__price--savings">'
      //     var save_html = boostPFSThemeConfig.label.save_html;
      //     save_html = save_html.replace(/{{ saved_amount }}/g, saved_amount);
      //     html += save_html
      //     html += '</span>'
      //   }
      // }
      var product_variant = firstVariant
      if (typeof product_variant.unit_price_measurement != 'undefined') {
        html += '<div class="product__unit-price">'
        var unit_price_base_unit = 0;
        if (product_variant.unit_price_measurement.reference_value != 1) {
          unit_price_base_unit = product_variant.unit_price_measurement.reference_value
        }
        unit_price_base_unit += product_variant.unit_price_measurement.reference_unit
        html += Utils.formatMoney(product_variant.unit_price).replace('.00', '') + '/ ' + unit_price_base_unit;
        html += '</div>'
      }
      html += '</span>';
    } else {
      if (priceVaries) {
        html += '<span class="grid-product__price--current">'
        var formatted_price = Utils.formatMoney(data.price_min).replace('.00', '')
        var raw_price = Utils.formatMoney(data.price_min).replace('.00', '')
        if (boostPFSAppConfig.shop.money_format.indexOf('money') == -1 || boostPFSAppConfig.shop.money_format.indexOf('.') == -1) {

          if (boostPFSThemeConfig.custom.superscript_decimals) {
            if (boostPFSAppConfig.shop.money_format.indexOf('{{amount}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount }}') == -1) {
              formatted_price = formatted_price.replace('.', '<sup>') + '</sup>'
            } else {
              if (boostPFSAppConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount_with_comma_separator }}') == -1) {
                formatted_price = formatted_price.replace(',', '<sup>') + '</sup>'
              }

            }
          }
          html += '<span aria-hidden="true" class="grid-product__price--from">' + boostPFSThemeConfig.label.from_text_html.replace(/{{ price }}/g, formatted_price); +'</span>'
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.from_text_html.replace(/{{ price }}/g, raw_price); +'</span>'
        }
        html += '</span>'
      } else {
        if (onSale) {
          html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.on_sale + '</span>';
          html += '<span class="grid-product__price--current price-color-red">'
        } else {
          html += '<span class="grid-product__price--current">'
        }
        var formatted_price = Utils.formatMoney(data.price_min).replace('.00', '')
        if (boostPFSAppConfig.shop.money_format.indexOf('money') == -1 || boostPFSAppConfig.shop.money_format.indexOf('.') == -1) {
          if (boostPFSThemeConfig.custom.superscript_decimals) {
            if (boostPFSAppConfig.shop.money_format.indexOf('{{amount}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount }}') == -1) {
              formatted_price = formatted_price.replace('.', '<sup>') + '</sup>'
            } else {
              if (boostPFSAppConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount_with_comma_separator }}') == -1) {
                formatted_price = formatted_price.replace(',', '<sup>') + '</sup>'
              }

            }
          }
          html += '<span aria-hidden="true">' + formatted_price.replace('.00', '') + '</span>'
          html += '<span class="visually-hidden">' + Utils.formatMoney(data.price_min).replace('.00', '') + '</span>'
        }
        html += '</span>'
      }

      if (onSale) {
        html += '<span class="visually-hidden">' + boostPFSThemeConfig.label.regular_price + '</span>'
        html += '<span class="grid-product__price--original">'
        var formatted_price_compare = Utils.formatMoney(data.compare_at_price_min).replace('.00', '')
        if (boostPFSAppConfig.shop.money_format.indexOf('money') == -1 || boostPFSAppConfig.shop.money_format.indexOf('.') == -1) {
          if (boostPFSThemeConfig.custom.superscript_decimals) {
            if (boostPFSAppConfig.shop.money_format.indexOf('{{amount}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount }}') == -1) {
              formatted_price_compare = formatted_price_compare.replace('.', '<sup>') + '</sup>'
            } else {
              if (boostPFSAppConfig.shop.money_format.indexOf('{{amount_with_comma_separator}}') != -1 || boostPFSAppConfig.shop.money_format.indexOf('{{ amount_with_comma_separator }}') == -1) {
                formatted_price_compare = formatted_price_compare.replace(',', '<sup>') + '</sup>'
              }

            }
          }
          html += '<span aria-hidden="true">' + formatted_price_compare + '</span>'
          html += '<span class="visually-hidden">' + Utils.formatMoney(data.compare_at_price_min).replace('.00', '') + '</span>'
        }
        html += '</span>'
        // var saved_amount = 0;
        // if( boostPFSThemeConfig.custom.product_save_amount){
        //   if(boostPFSThemeConfig.custom.product_save_type == 'dollar'){
        //       saved_amount = Utils.formatMoney(data.compare_at_price_min - data.price_min).replace('.00','');
        //   }else{
        //       saved_amount = Math.round(((data.compare_at_price_min - data.price_min)*100.0)/ data.compare_at_price_min) + '%';
        //   }
        //   html += '<span class="grid-product__price--savings">'
        //   var save_html = boostPFSThemeConfig.label.save_html;
        //   save_html = save_html.replace(/{{ saved_amount }}/g, saved_amount);
        //   html += save_html
        //   html += '</span>'
        // }
      }
      var product_variant = firstVariant
      if (typeof product_variant.unit_price_measurement != 'undefined') {
        html += '<div class="product__unit-price">'
        var unit_price_base_unit = 0;
        if (product_variant.unit_price_measurement.reference_value != 1) {
          unit_price_base_unit = product_variant.unit_price_measurement.reference_value
        }
        unit_price_base_unit += product_variant.unit_price_measurement.reference_unit
        html += Utils.formatMoney(product_variant.unit_price).replace('.00', '') + '/ ' + unit_price_base_unit;
        html += '</div>'
      }
    }

    var productNotAvaialble = false;
    var product_tags = data.tags.join(',');
    var productTags = product_tags.toLowerCase();
    if (productTags.indexOf('hidden in mo') != -1 || productTags.indexOf('hidden in mo.') != -1) {
      if (countryIsoCode === 'MO') {
        productNotAvaialble = true;
      }
    }

    if (productNotAvaialble) {
      html += '<p class="grid-product__not-available">';
      html += boostPFSThemeConfig.label.grid_item_not_available;
      html += '</p>';
    }

    return html;
  }
  function buildSwatch(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.enable_swatches) {
      var swatch_trigger = boostPFSThemeConfig.label.color_swatch_trigger;
      var options = data.options_with_values;
      for (index in data.options_with_values) {
        var option = options[index];
        var option_name = option['name'];
        option_name = option_name.toLowerCase();
        var is_color = false;
        if (option_name.indexOf(swatch_trigger) != -1) {
          is_color = true
        } else {
          if (swatch_trigger == 'color' && option_name.indexOf('colour') != -1)
            is_color = true
        }
        if (is_color) {
          var option_index = index;
          var values = [];
          var variants = data.variants;
          for (i in variants) {
            var variant = variants[i];
            if (typeof variant.options != 'undefined') {
              var value = variant.options[option_index];
              if (!values.includes(value)) {
                values.push(value);
                if (variant.image != null) {
                  html += '<div class="grid-product__color-image grid-product__color-image--' + variant.id + '"></div>';
                }
              }
            }
          }
        }
      }
    }
    return html;
  }
  function buildSwatchBottom(data) {
    var html = '';
    if (boostPFSThemeConfig.custom.enable_swatches) {
      var swatch_trigger = boostPFSThemeConfig.label.color_swatch_trigger;
      var watch_file_extension = 'png';
      var color_count = 0;
      var max_colors_show = 4;
      var more_than_max = false;
      var options = data.options_with_values;
      for (index in data.options_with_values) {
        var option = options[index];
        var option_name = option['name'];
        option_name = option_name.toLowerCase();
        var is_color = false;
        if (option_name.indexOf(swatch_trigger) != -1) {
          is_color = true
        } else {
          if (swatch_trigger == 'color' && option_name.indexOf('colour') != -1)
            is_color = true
        }
        if (is_color) {
          var option_index = index;
          var values = [];
          var variants = data.variants;
          html += '<div class="grid-product__colors">';
          for (i in variants) {
            var variant = variants[i];
            if (typeof variant.options != 'undefined') {
              var value = variant.options[option_index];
              if (!values.includes(value)) {
                values.push(value);

                var color_file_name = value;
                color_file_name = color_file_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '') + '.' + watch_file_extension;
                var color_swatch_fallback = value.split(' ')
                var color_swatch_fallback = color_swatch_fallback[color_swatch_fallback.length - 1];
                color_swatch_fallback = color_swatch_fallback.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                console.log(color_swatch_fallback)
                color_count = color_count + 1
                if (color_count <= max_colors_show) {
                  html += '<span class="color-swatch color-swatch--small color-swatch--' + value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                  if (variant.image != null) {
                    html += ' color-swatch--with-image"'
                  }
                  var variantUrl = Utils.buildProductItemUrlWithVariant(data);
                  html += ' data-url="' + variantUrl + '"'
                  if (variant.image != null) {
                    html += ' data-variant-id="' + variant.id + '"'
                    html += ' data-variant-image="' + Utils.optimizeImage(variant.image, '400x') + '"'
                  }
                  html += ' style="background-color: ' + color_swatch_fallback + '">'
                  html += '<span class="visually-hidden"> ' + value + '</span>'
                  html += '</span>'
                } else {
                  more_than_max = true
                }
              }
            }
          }
          if (more_than_max) {
            var more_colors = color_count - max_colors_show
            html += '<small class="color-swatch__more">+' + more_colors + '</small>';
          }
          html += '</div>';
        }
      }
    }
    return html;
  }
  function buildhideAddToCartClass(data) {
    var html = '';
    var product_tags = data.tags.join(',');
    var productTags = product_tags.toLowerCase();
    if (productTags.indexOf('comingsoon') != -1 || productTags.indexOf('sold out') != -1) {
      html = 'hideAddToCart';
    }

    if (productTags.indexOf('hidden in mo') != -1 || productTags.indexOf('hidden in mo.') != -1) {
      if (countryIsoCode === 'MO') {
        html = 'hideAddToCart';
      }
    }

    return html;
  }
  function buildLabels(data) {
    var on_sale = false;
    var soldOut = !data.available;
    var hideoos = false;

    var html = '';
    if (data.compare_at_price_min > data.price_min) {
      on_sale = true
    }

    var product_tags = data.tags.join(',');
    var productTags = product_tags.toLowerCase();
    if (productTags.indexOf('hidesale') != -1) {
      on_sale = false;
    }
    if (productTags.indexOf('hideoos') != -1) {
      hideoos = true;
    }
    var has_custom_label = false;
    if (data.metafields.theme) {
      if (data.metafields.theme.label && data.metafields.theme.label != blank) {
        var has_custom_label = true
        html += '<div class="grid-product__tag grid-product__tag--custom">'
        html += product.metafields.theme.label.value
        html += '</div>'
      }
    } else {
      for (i in product_tags) {
        var tag = product_tags[i];
        if (tag.indexOf('_label_') != -1) {
          var tag_starts_with = tag.charAt(0);
          if (tag_starts_with == '_') {
            has_custom_label = true;
            var custom_label = tag.replace('_label_', '');
            html += '<div class="grid-product__tag grid-product__tag--custom">'
            html += custom_label;
            html += '</div>'
          }
        }

      }
    }

    if (soldOut && !hideoos) {
      html += '<div class="grid-product__tag grid-product__tag--sold-out">'
      html += boostPFSThemeConfig.label.sold_out;
      html += '</div>'
    } else {
      if (on_sale) {
        html += '<div class="grid-product__tag grid-product__tag--sale">';
        var saved_amount = 0;
        if (boostPFSThemeConfig.custom.product_save_amount) {
          if (boostPFSThemeConfig.custom.product_save_type == 'dollar') {
            saved_amount = Utils.formatMoney(data.compare_at_price_min - data.price_min).replace('.00', '');
          } else {
            saved_amount = Math.round(((data.compare_at_price_min - data.price_min) * 100.0) / data.compare_at_price_min) + '%';
          }
        }
        html += boostPFSThemeConfig.label.save_html.replace(/{{ saved_amount }}/g, saved_amount);
        html += '</div>';
      }
    }

    return html;
  }
  function buildAction(data) {
    var html = '';
    var firstVariant = data['variants'][0];
    if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
      var paramVariant = data.variants.filter(function (e) {
        return e.id == Utils.getParam('variant');
      });
      if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
      for (var i = 0; i < data['variants'].length; i++) {
        if (data['variants'][i].available) {
          firstVariant = data['variants'][i];
          break;
        }
      }
    }
    if (boostPFSThemeConfig.custom.quick_add_enable || boostPFSThemeConfig.custom.quick_shop_enable) {
      html += '<div class="grid-product__actions">';
      if (boostPFSThemeConfig.custom.quick_add_enable) {
        html += '<button class="btn btn--circle btn--icon quick-product__btn quick-product__btn--not-ready js-modal-open-quick-modal-' + data.id + ' small--hide" title="' + boostPFSThemeConfig.label.quick_shop + '" tabindex="-1" data-handle="' + data.handle + '"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 64 64"><defs><style>.cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:2px}</style></defs><path class="cls-1" d="M47.16 28.58A18.58 18.58 0 1 1 28.58 10a18.58 18.58 0 0 1 18.58 18.58zM54 54L41.94 42"/></svg><span class="icon__fallback-text">' + boostPFSThemeConfig.label.quick_shop + '</span></button>';
      }
      if (boostPFSThemeConfig.custom.quick_add_enable && data.available) {
        if (data.variants.length > 1) {
          html += '<button type="button" class="text-link quick-add-btn js-quick-add-form js-modal-open-quick-add" title="' + boostPFSThemeConfig.label.add_to_cart + '" tabindex="-1"><span class="btn btn--circle btn--icon"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 64 64"><path class="cls-1" d="M32 9v46m23-23H9"/></svg><span class="icon__fallback-text">' + boostPFSThemeConfig.label.add_to_cart + '</span></span></button>';
        } else {
          html += '<button type="button" class="text-link quick-add-btn js-quick-add-btn"title="' + boostPFSThemeConfig.label.add_to_cart + '" tabindex="-1" data-id="' + firstVariant.id + '"><span class="btn btn--circle btn--icon"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" viewBox="0 0 64 64"><path class="cls-1" d="M32 9v46m23-23H9"/></svg><span class="icon__fallback-text">' + boostPFSThemeConfig.label.add_to_cart + '</span></span></button>';
        }
      }
      html += '</div>';
    }
    return html;
  }


  /************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
  /************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {

    if (!totalProduct) totalProduct = this.totalProduct;
    // Get page info
    var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
    var totalPage = Math.ceil(totalProduct / Utils.stripHtml(Globals.queryParams.limit));
    if (!currentPage || isNaN(currentPage)) {
      currentPage = 1;
    }
    // If it has only one page, clear Pagination
    if (totalPage <= 1) {
      return '';
    }

    var paginationHtml = boostPFSTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 4 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 4 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 3 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 3 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    return paginationHtml;
  };

  // Build Sorting
  ProductSorting.prototype.compileTemplate = function () {
    var html = '';
    if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
      var sortingArr = Utils.getSortingList();
      if (sortingArr) {
        // Build content
        var sortingItemsHtml = '';
        for (var k in sortingArr) {
          sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
        }
        html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      }
    }
    return html;
  };

  /************************** END BUILD TOOLBAR **************************/

  // Add additional feature for product list, used commonly in customizing product list
  ProductList.prototype.afterRender = function (data) {
    if (!data) data = this.data;

    // Intergrate Review Shopify
    if (window.SPR &&
      typeof window.SPR.initDomEls == 'function' &&
      typeof window.SPR.loadBadges == 'function' &&
      boostPFSThemeConfig.custom.show_product_review) {
      window.SPR.initDomEls();
      window.SPR.loadBadges();
    }

    var sections = new theme.Sections();
    sections.register('collection-template', theme.Collection);

    if (jQ('.flair-label').length > 0) {
      jQ('.flair-label').each(function () {
        if (jQ(this).html() == '') {
          var urlProduct = jQ(this).data('url') + '?view=labels';
          var __this = jQ(this);

          fetch(urlProduct)
            .then(response => {
              if (!response.ok) {
                throw new response;
              }
              return response.text();
            })
            .then(result => {
              __this.html(result);
            })
            .catch(error => { });
        }
      });
    }

    if (jQ('.flair-label-top').length > 0) {
      jQ('.flair-label-top').each(function () {
        if (jQ(this).html() == '') {
          var urlProduct = jQ(this).data('url') + '?view=labels-top';
          var __this = jQ(this);

          fetch(urlProduct)
            .then(response => {
              if (!response.ok) {
                throw new response;
              }
              return response.text();
            })
            .then(result => {
              __this.html(result);
            })
            .catch(error => { });
        }
      });
    }
  };

  // Build additional elements
  Filter.prototype.afterRender = function (data) {

    if (!data) data = this.data;
    var totalProduct = boostPFSThemeConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    if (data.total_product == 1) {
      totalProduct = boostPFSThemeConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    }
    if (data.total_product == 0) {
      jQ(".boost-pfs-filter-default-toolbar-inner").addClass('boost-pfs-filter-toolbar-product-0');
    } else {
      jQ(".boost-pfs-filter-default-toolbar-inner").removeClass('boost-pfs-filter-toolbar-product-0');
    }
    var currentPage = parseInt(Utils.stripHtml(Globals.queryParams.page));
    var loadMoreTotal = boostPFSThemeConfig.label.loadMoreTotal;
    var perPage = boostPFSThemeConfig.custom.products_per_page;
    var from = 1;
    var to = data.total_product;
    if (currentPage > 1) {
      to = currentPage * perPage;
      if (to > data.total_product)
        to = data.total_product
    }
    jQ('.boost-pfs-filter-load-more-total').html(loadMoreTotal.replace(/{{ total }}/g, data.total_product).replace(/{{ from }}/g, from).replace(/{{ to }}/g, to))

    jQ('.boost-pfs-filter-total-product').html(totalProduct);

    jQ('body').find('.boost-pfs-filter-skeleton-button').remove();

    var sortingItemsHtml = '';
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
      for (var k in sortingArr) {
        if (k != 'title-ascending' && k != 'title-descending') {
          activeClass = '';
          if (paramSort == k) {
            activeClass = 'class="selected"';
          }
          sortingItemsHtml += '<li data-sort="' + k + '" ' + activeClass + '>' + sortingArr[k] + '</li>';
        }
      }

      html = boostPFSTemplate.sortingHtml.replace(/{{default_sort_by}}/g, boostPFSThemeConfig.custom.default_sort_by);
      html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
    }
    var sortHTML = '<div id="sort-item" class="boost-pfs-filter-option boost-pfs-filter-option-list boost-pfs-filter-option-product-type boost-pfs-filter-has-scrollbar boost-pfs-filter-option-column-1 boost-pfs-filter-option-collapsed">'
    sortHTML += '<div class="boost-pfs-filter-option-title"><button aria-controls="boost-pfs-filter-tree-pf-pt-sort"  tabindex="0" aria-label="Sort" class="boost-pfs-filter-button boost-pfs-filter-option-title-heading" aria-expanded="false"><span class="boost-pfs-filter-option-title-text">Sort</span></button></div>'
    sortHTML += '<div class="boost-pfs-filter-option-content toggled" id="boost-pfs-filter-tree-pf-pt-sort" style="display: none;" ><div class="boost-pfs-filter-option-content-inner"><ul class="sort-mobile-list">'
    sortHTML += sortingItemsHtml
    sortHTML += '</ul></div></div>'
    sortHTML += '</div>'
    if (jQ('.sort-mobile-list').length == 0)
      jQ('.boost-pfs-filter-options-wrapper').prepend(sortHTML);
    // Prevent double tap on iOS
    var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (isiOS) {
      Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function () {
        isScrolling = !1
      }).on("touchmove", function () {
        isScrolling = !0
      }).on("touchend", function () {
        isScrolling || (window.location = jQ(this).attr("href"))
      });
    }

    if (typeof boostRemoveImageLoadingAnimation == 'function') {
      boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
    }

    // Layout Fullwidth Page
    if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') && boostPFSThemeConfig.custom.layout_type == 'fullwidth' && !Utils.isMobile()) {
      jQ('body').addClass('boost-pfs-filter-fullwidth-page');
    }
    document.addEventListener('scroll', function () {
      if (jQ('.boost-pfs-filter-tree-h.boost-pfs-filter-stick').length > 0 && jQ(window).width() > 767) {
        jQ('.boost-pfs-filter-custom-sorting .boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
      }
    });

    // Fix confict Sticky Mobile theme Streamline
    if (jQ('.site-nav__thumb-menu').length > 0 && Utils.isMobile()) {
      var heightHeaderThemeStick = jQ('.site-nav__thumb-menu').height() + 40;
      jQ('.boost-pfs-filter-tree-mobile-button-stick-wrapper').css('bottom', heightHeaderThemeStick).addClass('boost-pfs-filter-sticky-bottom');
      jQ('.boost-pfs-filter-mobile-style1').addClass('boost-pfs-filter-mobile-style1-sticky-bottom');
    }
  };

  function removeClassByPrefix(node, prefix) {
    var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
    node.className = node.className.replace(regx, '');
    return node;
  }


  ProductListPlaceholder.prototype.render = function () {
    // Set limit number for product skeleton
    var placeholderLimit = this.settings.productsPerRow || this.settings.placeholderProductPerRow;
    // Build placeholder items
    var placeholderItem = this.compileTemplate();
    this.$element = [];
    for (var i = 0; i < placeholderLimit; i++) {
      this.$element.push(jQ(placeholderItem));
    }
    // Show placeholder before send filter request OR hide it after get filter data
    if (!this.isFetchedProductData) {
      this.setShow();
    } else {
      this.setHide();
    }
  }

  ProductListPlaceholder.prototype.compileTemplateExtra = function () {
    //Todo: Build placeholder for List mode
    var template = boostPFSTemplate.productListPlaceholderHtml;
    var imgRatioSetting = parseFloat(this.settings.placeholderImageRatio);
    var imgRatio = imgRatioSetting > 0 ? imgRatioSetting : 1.4; // It mean w1:h1.4
    /**
     * Set product class for product skeleton (to set column, style, etc.)
     * - If had defined product_grid_class in boostPFSThemeConfig => use this config ELSE use our setting
     */
    return template
      .replace(/{{class.filterProductSkeleton}}/g, Class.filterProductSkeleton)
      .replace(/{{class.filterSkeleton}}/g, Class.filterSkeleton)
      .replace(/{{class.filterSkeletonText}}/g, Class.filterSkeletonText)
      .replace(/{{paddingTop}}/g, imgRatio * 100)
  }

  /* Prevent conflict with theme vendor js */
  Array.prototype.insert = function (a, b) { }

  // Build Placeholder for the first load
  function boostRemoveImageLoadingAnimation($selector) {
    if ($selector.length) {
      $selector.removeAttr('data-boost-image-loading-animation');
    }
  }
  /* Expand Filter */
  jQ(document).ready(function () {
    jQ('.boost-pfs-filter-custom-filter-button').on('click', function () {
      jQ('body').toggleClass('boost-pfs-filter-custom-drawer-open');
    });
    jQ('.boost-pfs-filter-custom-drawer-close').on('click', function () {
      jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
    });
    jQ('.boost-pfs-filter-custom-drawer-overlay').on('click', function () {
      jQ('body').removeClass('boost-pfs-filter-custom-drawer-open');
    });

    // Bind changing options with enter/space key for ADA
    jQ('.boost-pfs-filter-custom-drawer-close, .boost-pfs-filter-custom-drawer-overlay').on('keydown', (event) => {
      if (event.target && (event.keyCode == 13 || event.keyCode == 32)) {
        jQ(event.target).click();
      }
    });

    // Fix issue header fix on the Parallax theme
    if (jQ('.mm-fixed-top').length > 0) {
      var headerFixedHeight = jQ('.mm-fixed-top').height();
      jQ('.boost-pfs-filter-collection-header-wrapper').css('margin-top', headerFixedHeight);
    }
    jQ(document).on('click', '#sort-item .boost-pfs-filter-option-title', function (e) {
      jQ('#sort-item').toggleClass('boost-pfs-filter-option-collapsed')
      jQ('#boost-pfs-filter-tree-pf-pt-sort').toggle();
    });
    jQ(document).on('click', '.sort-mobile-list li', function (e) {
      jQ('.sort-mobile-list li').removeClass('selected')
      jQ(this).addClass('selected')
      jQ('#SortBy').val(jQ(this).data('sort'))
      jQ('#SortBy').trigger('change')
    });
  });

  // Start Boost 213276
  FilterApi.beforeCall = function (eventType, eventInfo) {
    Globals.queryParams.product_available = false;
    Globals.queryParams.variant_available = false;
  }
  // End Boost 213276  
})();